export enum PrerequisiteType {
  Agreement = 'agreement',
  IdentityCardCheck = 'identity-card-check',
}
